import { features } from '@/mocks/features';

export default function Features() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-50 text-primary-700 text-xs font-medium mb-4">
            mrds 核心功能
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            六大核心能力，全面赋能业务增长
          </h2>
          <p className="text-foreground-500 text-base max-w-[600px] mx-auto leading-relaxed">
            mrds 提供从数据处理到智能分析的全链路功能支持，帮助您轻松应对各类业务挑战
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}